import { render, staticRenderFns } from "./ToeflITPLevel1ScoreComponent.vue?vue&type=template&id=09f9151e&scoped=true&"
import script from "./ToeflITPLevel1ScoreComponent.vue?vue&type=script&lang=js&"
export * from "./ToeflITPLevel1ScoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToeflITPLevel1ScoreComponent.vue?vue&type=style&index=0&id=09f9151e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f9151e",
  null
  
)

export default component.exports